import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './ProductDetail.module.scss';
import classNames from 'classnames/bind';
import routes from '~/configs';
import ReactMarkdown from 'react-markdown';
import { BASE_URL_IMG } from '~/helper/apiService';

const cx = classNames.bind(styles);

const product = {
    "id": 12,
    "type_id": 1,
    "name": "Website 18 - CLOSET THỜI TRANG NỮ",
    "time": "12-2024",
    "language": "PHP HTML CSS JavaScript",
    "descriptions": "18 - Closet là một nền tảng bán lẻ thời trang nữ cao cấp, mang đến những sản phẩm thời trang theo xu hướng mới nhất với trải nghiệm mua sắm đơn giản và tiện lợi.",
    "content": "\n**GIỚI THIỆU DỰ ÁN WEBSITE 18 - CLOSET**\n\n### 1. Tổng quan về dự án\n\n18 - Closet là một nền tảng bán lẻ thời trang nữ cao cấp, mang đến những sản phẩm thời trang theo xu hướng mới nhất với trải nghiệm mua sắm đơn giản và tiện lợi. Website cung cấp đa dạng các danh mục sản phẩm như áo, áo khoác, váy, chân váy, quần, đầm, đồ bộ và set đồ.\n\n### 2. Công nghệ sử dụng\n\n- **Frontend**: HTML, CSS, Javascript\n- **Backend**: PHP\n- **Cơ sở dữ liệu**: MySQL\n- **Tính năng chính**:\n  - Hiển thị danh mục sản phẩm, ưu đãi hấp dẫn\n  - Hệ thống giỏ hàng, đặt hàng nhanh chóng\n  - Giao diện linh hoạt, tối ưu hiển thị trên mobile và desktop\n  - Bảo mật thông tin người dùng\n\n\n### 3. Link GitHub & Website\n\n- **GitHub Repository**: [https://github.com/luusytruong/fashion-store.git](https://github.com/luusytruong/fashion-store.git)\n- **Website Demo**: [https://18closet.ngogiaquyen.io.vn/](https://18closet.ngogiaquyen.io.vn/)\n\n###\n\nDự án 18 - Closet thể hiện kỹ năng lập trình và triển khai thực tế, hứa hẹn mang đến trải nghiệm mua sắm tiện lợi, hiện đại. Hy vọng rằng sản phẩm này sẽ gây ấn tượng với nhà tuyển dụng!\n\n---\n\nTrang chủ\n\n![img](/assets/uploads/67d7f0e369d36_home1.webp)\n\n\n\n![img](/assets/uploads/67d7f12b29114_home3.webp)\n\n\n\n![img](/assets/uploads/67d7f1485e27f_home4.webp)\n\nChi tiết sản phẩm\n\n\n![img](/assets/uploads/67d7f17a6563c_chi_ti___t_spa1.webp)\n\nGiỏ hàng\n\n![img](/assets/uploads/67d7f1a06039b_giohang.webp)\nĐặt hàng\n\n![img](/assets/uploads/67d7f1ca999f8_thanht_o__n.webp)\nThông tin đơn hàng\n\n\n![img](/assets/uploads/67d7f21520f6f_thong_tin_don_hang.webp)\n\nLiên hệ\n\n![img](/assets/uploads/67d7f23cba957_li__n_h___.webp)\n\n",
    "github_link": "https://github.com/luusytruong/fashion-store.git",
    "image": "/assets/uploads/67d7f3990e2d8_home1.webp",
    "date_create": "2025-03-18 00:04:09",
    "created_at": null,
    "updated_at": null
}

const ProductDetail = () => {

  return (
    <div className={cx('container')}>
      <header className={cx('header')}>
        <Link to={routes.projects} className={cx('back-link')}>
          <i className="fas fa-arrow-left"></i> Back
        </Link>
      </header>

      <main className={cx('main')}>
        <div className={cx('product-detail')}>
          {/* Left content */}
          <div className={cx('left-content')}>
            <div className={cx('product-header')}>
              <img
                src={BASE_URL_IMG + product.image}
                alt={`${product.name} icon`}
                className={cx('product-icon')}
                width="64"
                height="64"
              />
              <div>
                <h1 className={cx('product-title')}>
                  <span>{product.name}</span>
                  <span className={cx('platform')}>for {product.platform}</span>
                </h1>
              </div>
            </div>
            <nav className={cx('info-nav')}>
              <Link to="#" className={cx('info-nav-link', 'active')}>Information</Link>
            </nav>
            
            <ReactMarkdown>{product.content}</ReactMarkdown>
          </div>
          {/* Right sidebar */}
          <aside className={cx('sidebar')}>
            <div className={cx('screenshot-container')}>
              <img
                src={product.screenshot}
                alt={`${product.name} screenshot`}
                className={cx('screenshot')}
                width="280"
                height="140"
              />
              <div className={cx('image-counter')}>
                <span>1/1</span>
                <i className="fas fa-image"></i>
              </div>
            </div>
            <div className={cx('specs')}>
              <dl>
                <div className={cx('spec-item')}>
                  <dt>Latest update:</dt>
                  <dd>{product.latestUpdate}</dd>
                </div>
                <div className={cx('spec-item')}>
                  <dt>Platform: </dt>
                  <dd>{product.platform}</dd>
                </div>
                <div className={cx('spec-item')}>
                  <dt>Language:</dt>
                  <dd>{product.language}</dd>
                </div>
                <div className={cx('spec-item')}>
                  <dt>Size: </dt>
                  <dd>{product.size}</dd>
                </div>
                <div className={cx('spec-item')}>
                  <dt>Developer</dt>
                  <dd>
                    <Link to="#" className={cx('link')}>Quyen</Link> |{' '}
                    <Link to="#" className={cx('link')}>More programs</Link>
                  </dd>
                </div>
              </dl>
            </div>
            <button className={cx('contact-button')}>
              <span>Tải xuống</span>
              <span>cho {product.platform}</span>
              <i className="fas fa-envelope"></i>
            </button>
          </aside>
        </div>
      </main>
    </div>
  );
};

export default ProductDetail;